import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  StyledContainerItems,
  StyledTitleSideBar,
  StyledContainerFooterSideBar,
  ButtonStyled
} from '../../../../components/commons/SideBarComponents/sideBarComponentsStyles';
import Strings from '../../../../i18n';
import { SideBarEditablePropertyItem } from '../../../../components/commons/SideBarComponents/EditablePropertyItem/sideBarEditablePropertyItem';
import { SideBarSimpleMethodItem } from '../../../../components/commons/SideBarComponents/SimpleMethodItem/sideBarSimpleMethodButtonItem';
import { ClearButtonForFilter } from '../../../../components/commons/SideBarComponents/ClearButtonForFilter/clearButtonForFilter';
import { SelectItemMethod } from '../../../../components/commons/SideBarComponents/SelectItemMethod/selectItemMethod';
import { EFFECTS_STATUS } from '../../../../constants/effectsEnums';
import { SideBarSwitchWithLabel } from '../../../../components/commons/SideBarComponents/SwitchWithLabel/sideBarSwitchWithLabel';

interface EffectStoreFiltersProps {
  reloadTable: () => void;
  setOpenRightSideBar: (value: boolean) => void;
  openRightSideBar: boolean;
}
export const EffectStoreFilters = ({
  reloadTable,
  setOpenRightSideBar,
  openRightSideBar
}: EffectStoreFiltersProps) => {
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const filterByDescription = queryParams.get('filterByDescription');
  const filterByStatus = queryParams.get('filterByStatus');
  const filterByUserName = queryParams.get('filterByUserName');
  const filterByName = queryParams.get('filterByName');
  const filterByIsHaven = queryParams.get('filterByIsHaven');
  const filterByIsDefaultInLoc = queryParams.get('filterByIsDefaultInLoc');
  const [filters, setFilters] = useState({
    filterByDescription: filterByDescription || '',
    filterByStatus: filterByStatus || '',
    filterByUserName: filterByUserName || '',
    filterByName: filterByName || '',
    filterByIsHaven: Boolean(filterByIsHaven) || false,
    filterByIsDefaultInLoc: Boolean(filterByIsDefaultInLoc) || false
  });
  const closeSideBar = () => {
    setOpenRightSideBar(false);
  };

  const applyFilters = () => {
    const filterConfig = [
      {
        key: 'filterByDescription',
        value: filters.filterByDescription
      },
      {
        key: 'filterByStatus',
        value: filters.filterByStatus,
        useSelectedModel: false
      },
      {
        key: 'filterByUserName',
        value: filters.filterByUserName
      },
      {
        key: 'filterByName',
        value: filters.filterByName
      },
      {
        key: 'filterByIsHaven',
        value: filters.filterByIsHaven
      },
      {
        key: 'filterByIsDefaultInLoc',
        value: filters.filterByIsDefaultInLoc
      }
    ];

    filterConfig.forEach((filter) => {
      if (filter.value) {
        queryParams.set(filter.key, filter.value.toString());
      } else {
        queryParams.delete(filter.key);
      }
    });

    navigate(`?${queryParams.toString()}`);
    reloadTable();
    closeSideBar();
  };

  const removeFilters = () => {
    const newUrl = window.location.pathname;
    setFilters({
      filterByDescription: '',
      filterByStatus: '',
      filterByUserName: '',
      filterByName: '',
      filterByIsHaven: false,
      filterByIsDefaultInLoc: false
    });
    navigate(newUrl);
    reloadTable();
    closeSideBar();
  };

  return (
    <>
      <StyledContainerItems>
        <StyledTitleSideBar>{Strings.common.filters}</StyledTitleSideBar>
        <ClearButtonForFilter
          filterName="filterByDescription"
          clearFilter={() =>
            setFilters({ ...filters, filterByDescription: '' })
          }
          filters={filters}
        >
          <SideBarEditablePropertyItem
            item={{
              label: Strings.effects.filters.filterByDescription,
              type: 'inputText',
              currentValue: filters.filterByDescription,
              placeholder: '',
              nameAndId: 'filterByDescription',
              onChange: (
                event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
              ) =>
                setFilters({
                  ...filters,
                  filterByDescription: event.target.value
                })
            }}
          />
        </ClearButtonForFilter>
        <SelectItemMethod
          clearAction={() => setFilters({ ...filters, filterByStatus: '' })}
          showClear={filters.filterByStatus !== ''}
          item={{
            label: Strings.effects.filters.filterByStatus,
            currentValue: filters.filterByStatus,
            options: [
              {
                id: EFFECTS_STATUS.WAITINGFORREVIEW,
                name: Strings.effects.waitingForReview
              },
              {
                id: EFFECTS_STATUS.APPROVED,
                name: Strings.effects.approved
              },
              {
                id: EFFECTS_STATUS.DENIED,
                name: Strings.effects.denied
              }
            ],
            onChange: (
              event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
            ) =>
              setFilters({
                ...filters,
                filterByStatus: event.target.value
              })
          }}
        />
        <SideBarSwitchWithLabel
          label={Strings.effects.filters.filterByIsHaven}
          checked={filters.filterByIsHaven}
          onChange={() =>
            setFilters({
              ...filters,
              filterByIsHaven: !filters.filterByIsHaven
            })
          }
        />
        <SideBarSwitchWithLabel
          label={Strings.effects.filters.filterByIsDefaultInLoc}
          checked={filters.filterByIsDefaultInLoc}
          onChange={() =>
            setFilters({
              ...filters,
              filterByIsDefaultInLoc: !filters.filterByIsDefaultInLoc
            })
          }
        />
        <ClearButtonForFilter
          filterName="filterByName"
          clearFilter={() => setFilters({ ...filters, filterByName: '' })}
          filters={filters}
        >
          <SideBarEditablePropertyItem
            item={{
              label: Strings.effects.filters.filterByName,
              type: 'inputText',
              currentValue: filters.filterByName,
              placeholder: '',
              nameAndId: 'filterByName',
              onChange: (
                event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
              ) =>
                setFilters({
                  ...filters,
                  filterByName: event.target.value
                })
            }}
          />
        </ClearButtonForFilter>
        <ClearButtonForFilter
          filterName="filterByUserName"
          clearFilter={() => setFilters({ ...filters, filterByUserName: '' })}
          filters={filters}
        >
          <SideBarEditablePropertyItem
            item={{
              label: Strings.effects.filters.filterByUserName,
              type: 'inputText',
              currentValue: filters.filterByUserName,
              placeholder: '',
              nameAndId: 'filterByUserName',
              onChange: (
                event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
              ) =>
                setFilters({
                  ...filters,
                  filterByUserName: event.target.value
                })
            }}
          />
        </ClearButtonForFilter>
        <SideBarSimpleMethodItem
          name={Strings.common.removeFilters}
          action={() => removeFilters()}
          successAction={false}
          textSuccess="success"
        />
      </StyledContainerItems>
      <StyledContainerFooterSideBar>
        <button
          type="button"
          className="btn-cancel"
          onClick={() => closeSideBar()}
        >
          {Strings.common.cancel}
        </button>
        <button
          type="button"
          className="btn-save"
          onClick={() => {
            applyFilters();
          }}
        >
          {Strings.common.apply}
        </button>
      </StyledContainerFooterSideBar>
    </>
  );
};
